import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_contained/invoices/")({
  loader: async () => {
    throw redirect({ to: "/customers", search: { tab: "invoices" } });
  },
});
